import { FormEvent, useEffect, useState } from "react";
import { api } from "../api";
import type { Company } from "../types";

type Flash = { kind: "ok" | "error"; text: string } | null;
type Props = { companies: Company[]; canManage: boolean; reload: () => void; flash: (value: Flash) => void };
const numberOrNull = (value: string) => value === "" ? null : Number(value);

export default function CurrentFlowRulesPage({ companies, canManage, reload, flash }: Props) {
  const [companyId, setCompanyId] = useState(companies[0]?.id ?? 0);
  const [draft, setDraft] = useState<Company | null>(companies[0] ?? null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { setDraft(companies.find((item) => item.id === companyId) ?? null); }, [companies, companyId]);
  async function save(event: FormEvent) {
    event.preventDefault();
    if (!draft) return;
    setSaving(true);
    try {
      const { id, ...payload } = draft;
      await api(`/api/companies/${id}`, { method: "PUT", body: JSON.stringify(payload) });
      reload();
      flash({ kind: "ok", text: "Parâmetros do fluxo atual atualizados." });
    } catch (error) { flash({ kind: "error", text: error instanceof Error ? error.message : "Falha ao salvar regra" }); }
    finally { setSaving(false); }
  }
  return <>
    <div className="page-head"><div><p className="eyebrow">REGRA EM OPERAÇÃO</p><h1>Fluxo atual</h1>
      <p>Parâmetros do agendador existente enquanto a busca por grupos e o FGTS por vencimento são preparados.</p>
    </div></div>
    <div className="notice">Este fluxo ainda emite o DARF completo e consulta todas as GFD da competência. A data inicial abaixo é legada e será substituída pelas regras de vencimento quando os novos processos forem ativados.</div>
    <section className="card darf-filters"><label>Empresa
      <select value={companyId} onChange={(event) => setCompanyId(Number(event.target.value))}>
        {companies.map((company) => <option key={company.id} value={company.id}>{company.trade_name || company.legal_name}</option>)}
      </select>
    </label></section>
    {draft && <section className="card"><form className="form-grid" onSubmit={save}>
      <label>Dia inicial da busca atual<input type="number" min="1" max="28" required disabled={!canManage} value={draft.search_start_day} onChange={(event) => setDraft({ ...draft, search_start_day: Number(event.target.value) })} /></label>
      <label>Horário<input type="time" required disabled={!canManage} value={draft.search_time} onChange={(event) => setDraft({ ...draft, search_time: event.target.value })} /></label>
      <label>Competência<select disabled={!canManage} value={draft.competence_offset_months ?? ""} onChange={(event) => setDraft({ ...draft, competence_offset_months: numberOrNull(event.target.value) })}>
        <option value="">Padrão geral</option><option value="0">Mês atual</option><option value="1">Mês anterior</option><option value="2">Dois meses atrás</option><option value="3">Três meses atrás</option>
      </select></label>
      <label>Intervalo entre tentativas<select disabled={!canManage} value={draft.recurrence_days ?? ""} onChange={(event) => setDraft({ ...draft, recurrence_days: numberOrNull(event.target.value) })}>
        <option value="">Padrão geral</option><option value="1">Diariamente</option><option value="2">A cada 2 dias</option><option value="3">A cada 3 dias</option><option value="7">Semanalmente</option>
      </select></label>
      <label>Prioridade na fila<select disabled={!canManage} value={draft.processing_priority ?? ""} onChange={(event) => setDraft({ ...draft, processing_priority: numberOrNull(event.target.value) })}>
        <option value="">Padrão geral</option><option value="200">Alta</option><option value="100">Normal</option><option value="50">Baixa</option>
      </select></label>
      <label>Retenção do PDF (dias)<input type="number" min="1" max="3650" disabled={!canManage} placeholder="Padrão geral" value={draft.pdf_retention_days ?? ""} onChange={(event) => setDraft({ ...draft, pdf_retention_days: numberOrNull(event.target.value) })} /></label>
      {canManage && <footer className="wide"><button className="primary" disabled={saving}>{saving ? "Salvando…" : "Salvar parâmetros"}</button></footer>}
    </form></section>}
  </>;
}
